import $ from 'jquery';

const filterListWem = function () {
    var filterCardPreSet = $('.js-filter-list-card');  
    
    $(filterCardPreSet).each(function(i, elem) {
    	var currentId = $(elem).attr("data-id");
    	var currentFilterCardElms = $(".js-filter-list-card[data-id='" + currentId + "']");
    	var cardToKeep = $(currentFilterCardElms).first();
        
    	if ($(currentFilterCardElms).length > 1){
    		$(currentFilterCardElms).each(function(i, cardWithSameId) {
    			if (i === 0) return;

                var currentCat = $(cardWithSameId).attr("data-category");
                var catAttr = $(cardToKeep).attr("data-category");

                // Take INT index of current category card
                var indexCat = currentCat.replace('category-','');

                // Take order INT of the card in current category
                var currentCatOrder = $(cardWithSameId).attr('data-category_order_'+indexCat);

                // Add current category to the unique card
                catAttr += ' ';
                catAttr += currentCat;
                $(cardToKeep).attr("data-category", catAttr);
                $(cardToKeep).attr('data-category_order_'+indexCat, currentCatOrder);

    			$(cardWithSameId).remove();
    		});
    	}
		
		$(cardToKeep).removeAttr('data-id');
	});
};

export {filterListWem};


// WEBPACK FOOTER //
// ./src/js/cms/commons/filter-list-wem.js